// @flow

import {InputCommand} from '../../terminal/command';
import {search, parsePath, Pages} from '../executables/docs_navtree';

export class DirectorySuggestions {
  run(inputCommand: InputCommand, _: any): Array<[string, {}]> {
    const empty: Array<[string, {}]> = [['', {}]];

    const currentPage = search(window.location.pathname, Pages());
    // The bottom will only hit in cases where the user is on a page
    // that doesn't exist (which right now will be any error page or
    // gated/flagged pages)
    if (currentPage === null) {
      return empty;
    }

    const command = inputCommand.structuredArgs.join(' ');

    if (command === '') {
      const children = currentPage.children;
      const recommendations: Array<[string, {}]> = children.map((p) => {
        return [p.slug, {}];
      });

      return recommendations;
    } else if (command.includes('/')) {
      // clean = command.endsWith('/') ? command.slice(0, -1) : command;
      // const path = relativePath(currentPage);
      const splitPath = command.split('/');
      const last = splitPath.pop();
      const currentPath = splitPath.join('/');

      const page = parsePath(currentPath, currentPage);
      if (page === null) {
        return empty;
      }

      const recommendations = page.children
        .filter((p) => {
          return p.slug.startsWith(last);
        })
        .map((p) => {
          return [p.slug, {}];
        });

      return recommendations;
    } else {
      const recommendations = currentPage.children
        .filter((p) => {
          return p.slug.startsWith(command);
        })
        .map((p) => {
          return [p.slug, {}];
        });
      return recommendations;
    }

    // todo -
    // 4. argument, starts with ~ (or /)
    // n. create jump command (fuzzy find)
  }
}
